import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useSessionPost = () => {
  const createSession = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/session/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createSession);
};

export default useSessionPost;
